import Vue from 'vue'
import Router from 'vue-router'
import Cart from '@/components/cart/cart'
import Index from '@/components/index/index'
import explosive from '@/components/index/explosive'
//import moreclass from '@/components/index/moreclass'
import recommend from '@/components/index/recommend'
import searchlist from '@/components/index/searchlist'
import listdetail from '@/components/index/listdetail'
import placeorder from '@/components/index/placeorder'
import Tabbar from '@/components/tabbar'
import Information from '@/components/information/information'
import myorder from '@/components/information/myorder'
import orderdetail from '@/components/information/orderdetail'
import evaluate from '@/components/information/evaluate'
import replaceType from '@/components/information/replaceType'
import replacement from '@/components/information/replacement'
import replacementlist from '@/components/information/replacementlist'
import replacementdetail from '@/components/information/replacementdetail'
import collect from '@/components/information/collect'
import coupon from '@/components/information/coupon'
import couponCommodity from '@/components/information/couponCommodity'
import couponhistory from '@/components/information/couponhistory'
import recharge from '@/components/information/recharge'
import withdrawcash from '@/components/information/withdrawcash'
import addresslist from '@/components/information/addresslist'
import addaddress from '@/components/information/addaddress'
import logistics from '@/components/information/logistics'
import announcement from '@/components/information/announcement'
import myNotice from '@/components/index/myNotice'
import myNoticeYj from '@/components/index/myNoticeYj'
import editInfo from '@/components/information/editInfo'
import expressApply from '@/components/information/expressApply'
import turn from '@/components/index/turn'
import setting from '@/components/information/setting'
import myReward from '@/components/index/myReward'
import feedback from '@/components/index/feedback'
import rewardDetail from '@/components/index/rewardDetail'
import material from '@/components/index/material'
import materialDetail from '@/components/index/materialDetail'
import securities from '@/components/index/securities'
import login from '@/components/index/login'
import comodityMaterial from '@/components/index/comodityMaterial'
import payMask from '@/components/index/payMask'
import areaCoupon from '@/components/index/areaCoupon'
import payResult from '@/components/index/payResult'
import payResultFollow from '@/components/index/payResultFollow'
import download from '@/components/index/download'
import giftCard from '@/components/information/giftCard'
import news from '@/components/information/news'
import newsDetail from '@/components/information/newsDetail'
import storeList from '@/components/index/storeList'
import signResult from '@/components/information/signResult'
import authResult from '@/components/information/authResult'
import fingerpost from '@/components/information/fingerpost'
import fingerpostDetail from '@/components/information/fingerpostDetail'
import iframe from '@/components/index/iframe'
import sourceList from '@/components/index/sourceList'
import sourceListdetail from '@/components/index/sourceListdetail'
import sourceDetail from '@/components/index/sourceDetail'

import equityDetail from '@/components/equity/equityDetail'
import equityPlaceorder from '@/components/equity/equityPlaceorder'
import equityResult from '@/components/equity/equityResult'
import myEquity from '@/components/equity/myEquity'
import credential from '@/components/index/credential'
import rankList from '@/components/index/rankList'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'tabbar',
      component: Tabbar,
      redirect:'/index',
      children:[
        {
          path: '/index',
          name: 'index',
          component: Index,
          meta: {
            keepAlive: true, //此组件需要被缓存
          }
        },
        {
          path: '/cart',
          name: 'cart',
          component: Cart,
          meta: {
            keepAlive: true, //此组件需要被缓存
          }
        },
        {
          path: '/information',
          name: 'information',
          component: Information,
          meta: {
            keepAlive: true, //此组件需要被缓存
          }
        },
        {
          path: '/recommend',
          name: 'recommend',
          component: recommend,
          meta: {
            keepAlive: true, //此组件需要被缓存
          }
        },
      ]
    },
    {
      path: '/download',
      name: 'download',
      component: download,
    },
    {
      path: '/explosive',
      name: 'explosive',
      component: explosive,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/storeList',
      name: 'storeList',
      component: storeList,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/searchlist',
      name: 'searchlist',
      component: searchlist,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/listdetail',
      name: 'listdetail',
      component: listdetail
    },
    {
      path: '/myNotice',
      name: 'myNotice',
      component: myNotice
    },
    {
      path: '/myNoticeYj',
      name: 'myNoticeYj',
      component: myNoticeYj,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/placeorder',
      name: 'placeorder',
      component: placeorder,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/myorder',
      name: 'myorder',
      component: myorder,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/orderdetail',
      name: 'orderdetail',
      component: orderdetail
    },
    {
      path: '/setting',
      name: 'setting',
      component: setting
    },
    {
      path: '/editInfo',
      name: 'editInfo',
      component: editInfo
    },
    {
      path: '/evaluate',
      name: 'evaluate',
      component: evaluate
    },
    {
      path: '/replaceType',
      name: 'replaceType',
      component: replaceType
    },
    {
      path: '/replacement',
      name: 'replacement',
      component: replacement
    },
    {
      path: '/replacementlist',
      name: 'replacementlist',
      component: replacementlist,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/replacementdetail',
      name: 'replacementdetail',
      component: replacementdetail
    },
    {
      path: '/collect',
      name: 'collect',
      component: collect,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: coupon
    },
    {
      path: '/couponCommodity',
      name: 'couponCommodity',
      component: couponCommodity
    },
    {
      path: '/couponhistory',
      name: 'couponhistory',
      component: couponhistory
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge
    },
    {
      path: '/expressApply',
      name: 'expressApply',
      component: expressApply,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/withdrawcash',
      name: 'withdrawcash',
      component: withdrawcash
    },
    {
      path: '/addresslist',
      name: 'addresslist',
      component: addresslist
    },
    {
      path: '/addaddress',
      name: 'addaddress',
      component: addaddress
    },

    {
      path:'/credential',
      name:'credential',
      component:credential
    },
    {
      path: '/logistics',
      name: 'logistics',
      component: logistics
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: announcement,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/turn',
      name: 'turn',
      component: turn,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/myReward',
      name: 'myReward',
      component: myReward,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback,
    },
    {
      path: '/rewardDetail',
      name: 'rewardDetail',
      component: rewardDetail,
    },
    {
      path: '/comodityMaterial',
      name: 'comodityMaterial',
      component: comodityMaterial,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/material',
      name: 'material',
      component: material,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/materialDetail',
      name: 'materialDetail',
      component: materialDetail,
    },
    {
      path: '/areaCoupon',
      name: 'areaCoupon',
      component: areaCoupon,
    },
    {
      path: '/securities',
      name: 'securities',
      component: securities,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/payMask',
      name: 'payMask',
      component: payMask,
    },
    {
      path: '/payResult',
      name: 'payResult',
      component: payResult,
    },
    {
      path: '/payResultFollow',
      name: 'payResultFollow',
      component: payResultFollow,
    },
    {
      path: '/giftCard',
      name: 'giftCard',
      component: giftCard,
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/newsDetail/:nbr',
      name: 'newsDetail',
      component: newsDetail
    },
    {
      path: '/authResult',
      name: 'authResult',
      component: authResult
    },
    {
      path: '/signResult',
      name: 'signResult',
      component: signResult
    },
    {
      path: '/equityDetail',
      name: 'equityDetail',
      component: equityDetail
    },
    {
      path: '/equityPlaceorder',
      name: 'equityPlaceorder',
      component: equityPlaceorder,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/equityResult',
      name: 'equityResult',
      component: equityResult
    },
    {
      path: '/myEquity',
      name: 'myEquity',
      component: myEquity
    },
    {
      path: '/fingerpost',
      name: 'fingerpost',
      component: fingerpost,
    },
    {
      path: '/fingerpostDetail',
      name: 'fingerpostDetail',
      component: fingerpostDetail
    },
    {
      path: '/iframe',
      name: 'iframe',
      component: iframe
    },
    {
      path: '/sourceList',
      name: 'sourceList',
      component: sourceList,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/sourceListdetail',
      name: 'sourceListdetail',
      component: sourceListdetail
    },
    {
      path: '/sourceDetail',
      name: 'sourceDetail',
      component: sourceDetail
    },
    {
      path: '/rankList',
      name: 'rankList',
      component: rankList,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js